<template>
  <b-container>
    <b-row>
      <b-col>
        <div class="d-flex text-center text-muted vertical-center">
          <div class="w-100">
            <div class="error-class">{{ code }}</div>
            <p class="mb-5 h6 text-dark">{{ $t('common.errors.message' + code) }}</p>
            <b-button size="sm" variant="primary" @click="goBack()">
              <i class="fas fa-chevron-left mr-1"></i> {{ $t('common.errors.goBack') }}
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { doLogout } from '../../plugins/authentication'

export default {
  name: 'HTTPError',

  props: {
    code: String,
    message: String,
  },

  methods: {
    doLogout,
    goBack() {
      if (this.code && this.code == '401') {
        this.doLogout()
      } else {
        this.$router.push({ name: 'index' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.vertical-center {
  min-height: calc(100% - 45px - 60px); /* Fallback for browsers do NOT support vh unit */
  min-height: calc(100vh - 45px - 60px); /* These two lines are counted as one */
  align-items: center;
}
.error-class {
  font-size: 10rem;
  color: var(--gray6);
}
</style>
